import Cookie from '@nuxt-common/util/app/utils/cookie/Cookie.js';
import { getUserGuid } from '#utils/UserDetails';
import { getError, getErrorMessage } from '#utils/ErrorHandler';
import { processErrorDetails } from '#utils/errorArrayDetails';
import { defineStore } from 'pinia';
import $http from '@vue-util/http';

const WISHLIST_ENDPOINT = '/xapi/wishlist/v1/lists';

export const useGetAllListsStore = defineStore('getAllLists', {
  state: () => ({
    allListsOfUser: {},
    userListsError: null,
    userListsErrorDetails: null,
    loadingState: false,
    errorStatus: false,
  }),
  actions: {
    async getUserLists({ listLimit = 0, headers }) {
      this.loadingState = true;
      this.errorStatus = false;
      this.userListsError = null;
      this.userListsErrorDetails = null;
      try {
        let url = `${WISHLIST_ENDPOINT}?userGuid=${getUserGuid()}&expand=userInfo&default=false&listType=w`;
        if (listLimit) {
          url += `&listLimit=${listLimit}`;
        }
        const response = await $http.get(url, {
          headers,
        });
        const responseData = response.data || response;
        if (!getError(responseData)) {
          const data = responseData?.CustomerList || {};
          this.allListsOfUser = data;
          return data;
        }
        const errorObj = getError(responseData);
        const errorDetails = processErrorDetails(errorObj);
        const errorMessage = getErrorMessage(responseData, 'GENERIC');
        this.userListsError = errorMessage;
        this.userListsErrorDetails = errorDetails;
        this.allListsOfUser = {};
      } catch (error) {
        if (error.response?.status === 401) {
          Cookie.set('SignedIn', '0');
          this.errorStatus = true;
        }
        const data = error?.response?.data;
        const errorObj = getError(data);
        const errorDetails = processErrorDetails(errorObj);
        const fallbackErrorMessage = getErrorMessage(error, 'BAD_REQUEST');
        this.userListsError = fallbackErrorMessage;
        this.userListsErrorDetails = errorDetails;
        this.allListsOfUser = {};
      } finally {
        this.loadingState = false;
      }
      return this.allListsOfUser;
    },
    setUserLists(lists) {
      this.allListsOfUser = lists;
    },
    setUserListsError(error) {
      this.userListsError = error;
    },
    setUserListsErrorDetails(errorDetails) {
      this.userListsErrorDetails = errorDetails;
    },
    setUserListsLoadingState(loadValue) {
      this.loadingState = loadValue;
    },
    setUserListsErrorStatus(value) {
      this.errorStatus = value;
    },
  },
});
